import { Component, Input, numberAttribute, OnChanges, QueryList, SimpleChanges, ViewChildren } from '@angular/core';
import { FilterBase } from 'src/app/shared/grid/filter-base';
import { GridFilterPopupComponent } from 'src/app/shared/grid/filters/base-filter-popup.component';
import { GridNumberRangeFilterComponent } from 'src/app/shared/grid/filters/grid-number-range-filter.component';

@Component({
    selector: 'grid-number-range-filter-popup',
    template: ` <grid-filter-popup
        [isFilterActive]="isFilterActive"
        (onResetClick)="onResetClick()"
        (onFilterClick)="onFilterClick()"
        (onClose)="onPopupClose()"
        [width]="width">
        <grid-number-range-filter
            [width]="width"
            [minTitle]="minTitle"
            [maxTitle]="maxTitle"
            [min]="min"
            [max]="max"
            [smallStep]="smallStep"
            [field]="field"
            [filter]="filter"
            [filterService]="filterService"
            (filterValueChanged)="filterValueChanged()"
            [submitOnChange]="false"
            [format]="format"
            [showSliders]="showSliders">
        </grid-number-range-filter>
    </grid-filter-popup>`,
    standalone: true,
    imports: [GridFilterPopupComponent, GridNumberRangeFilterComponent]
})
export class GridNumberRangeFilterPopupComponent extends FilterBase implements OnChanges {
    isFilterActive = false;
    @Input() minTitle = 'Min:';
    @Input() maxTitle = 'Max:';
    @Input() min = 0;
    @Input() max = 255;
    @Input() smallStep = 1;
    @Input({ transform: numberAttribute }) width = 350;
    @Input() format = 'n2';
    @Input() showSliders = true;

    @ViewChildren(FilterBase) filters: QueryList<FilterBase>;

    filterValueChanged() {
        const fromNumber = this.getLatestFilterValue(null, this.field + 'From');
        const toNumber = this.getLatestFilterValue(null, this.field + 'To');

        const fromNumberDefined = fromNumber !== null && fromNumber !== undefined;
        const toNumberDefined = toNumber !== null && toNumber !== undefined;
        const minFilterExceed: boolean = fromNumberDefined && fromNumber < this.min;
        const maxFilterExceed: boolean = toNumberDefined && toNumber > this.max;
        const minGreaterThanMax: boolean = fromNumberDefined && toNumberDefined && fromNumber > toNumber;

        this.isFilterActive =
            (fromNumberDefined || toNumberDefined) && !minFilterExceed && !maxFilterExceed && !minGreaterThanMax;
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes['filter']) {
            this.filterValueChanged();
        }
    }

    onResetClick(): void {
        this.trimFilterByField(this.filter, this.field + 'From');
        this.trimFilterByField(this.filter, this.field + 'To');
        this.submitFilter();
        this.filterValueChanged();
    }

    onFilterClick(): void {
        this.submitFilter();
    }

    onPopupClose(): void {
        if (this.isFilterActive) {
            if (this.filters.toArray().some((x) => x.isChanged)) {
                this.submitFilter();
            }
        }
    }

    submitFilter() {
        this.filters.toArray().forEach((x) => (x.isChanged = false));
        super.submitFilter();
    }
}
